export var TextFormat;
(function (TextFormat) {
    TextFormat[TextFormat["None"] = 0] = "None";
    TextFormat[TextFormat["Italic"] = 1] = "Italic";
    TextFormat[TextFormat["Bold"] = 2] = "Bold";
})(TextFormat || (TextFormat = {}));
